module.exports = {
      id: "ic-arrow-orange-usage",
      viewBox: "0 0 22 31",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-arrow-orange-usage",
      toString: function () {
        return this.url;
      }
    }